import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import FilterType from '../../../shared/enums/filter-type.enums';

@Component({
  selector: 'hdi-filter',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class FilterComponent {
  protected readonly FilterType = FilterType;

  @Input() isSelected = false;
  @Input() type: FilterType = FilterType.Button;
  @Input() label?: string;
  @Input() disabled?: boolean;
  @Output() clickEvent = new EventEmitter<string>();

  selectFilter = (): void => {
    this.isSelected = !this.isSelected;
    this.clickEvent.emit(this.label);
  };
}
